/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Commandmanp12Inputs */



/**
* | output |
* | --- |
* | "Left/top pump manual command" |
*
* @param {Ahu_History_Key_Commandmanp12Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_commandmanp12 = /** @type {((inputs?: Ahu_History_Key_Commandmanp12Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Commandmanp12Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Left/top pump manual command")
	return /** @type {LocalizedString} */ ("Commande manuelle pompe gauche/haute")
});
export { ahu_history_key_commandmanp12 as "ahu_history_key_commandManP1" }